import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { JWT_VAl } from "../jwt_validate";
import { Helmet } from "react-helmet";
import apihost from "../ApiHost";
import { getCookie,createCookie, deleteCookie } from "../CookieFunctions";

function Verify() {
  const re=getCookie("loginRedirect");
  const [formData, setFormData] = useState({
    OTP: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    const fetchData = async () => {
    const JWT = await JWT_VAl();
      if (JWT.success && JWT.verified) {
         window.location.href = re ? re : "https://insightnest.tech/";
      }
      if (JWT.success && !JWT.verified) {
        navigate("/verify");
      }
    }
    fetchData();
    }, [navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const {  OTP } = formData;
    let path=`${apihost}/auth/verify`;
    console.log(path);
    try {
      const response = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${localStorage.getItem("_JWT")}`
        },
        body: JSON.stringify({otp: OTP }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          // Save token to localStorage
          createCookie("_JWT", data._JWT);
          if(re){
            deleteCookie("loginRedirect");
            window.location.href = re;
        }else{
            deleteCookie("loginRedirect");
            window.location.href = "https://insightnest.com/";
        }
        }
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      alert("An error occurred while signing up.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <Helmet>
        <title>Insight Nest | Verify Email</title>
        <meta name="description" content="Verify your email address" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-5xl w-full flex flex-col sm:flex-row items-center">
        {/* Left Section - Text */}
        <div className="sm:w-1/2 w-full bg-gray-50 flex items-center justify-center p-8">
          <h2 className="text-4xl font-bold text-blue-600 leading-tight text-center sm:text-left">
            Verfiy Your Email <br />
          </h2>
        </div>
        {/* Right Section - Form */}
        <div className="sm:w-1/2 w-full p-8 bg-white rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center sm:text-left">Verify</h2>
          <form className="space-y-4" onSubmit={handleSubmit}>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                OTP
              </label>
              <input
                type="number"
                id="OTP"
                name="OTP"
                value={formData.OTP}
                onChange={handleChange}
                placeholder="OTP"
                className="w-full p-3 mt-1 border rounded-lg focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <button
              type="submit"
              className={`w-full p-3 rounded-lg transition duration-300 ${
                isLoading
                  ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify"}
            </button>
          </form>
          <p className="text-sm text-gray-500 mt-6 text-center sm:text-left">
            I don't have an account?{" "}
            <Link to={'/signup'} className="text-blue-600 hover:underline">
                Sign Up
            </Link>
          </p>
        </div>
      </div>
    </div>
    </>
  );
}

export default Verify;
